.tabs {
  display: flex;
}
.tab,
.sub-tab {
  padding: 6px 12px;
}
.tab:hover,
.sub-tab:hover {
  background-color: rgba(55, 88, 107, 0.5);
  cursor: pointer;
}
.tab,
.sub-tab {
  border-top: transparent 1px solid;
  border-left: transparent 1px solid;
}
.tab-active {
  border-top: #d8d8d8 1px solid;
}
.tab-active,
.sub-tab-active {
  border-left: #d8d8d8 1px solid;
  border-right: #d8d8d8 1px solid;
  font-weight: bold;
}

.line {
  width: 100%;
  height: 1px;
  background-color: #d8d8d8;
}
.italic {
  font-style: italic;
}
.background {
  background-color: #d9d9d9;
}
